<template>
  <video controls class="zoomed-video" ref="media" :loop="loop" v-if="showing" :muted="muted">
    <source :src="fullUrl" type="video/mp4" />
  </video>
</template>

<script>
export default {
  props:{
    url: String,
    autoplay: Boolean,
    loop: Boolean,
    muted: Boolean
  },
  computed: {
    fullUrl () {
      if(this.url) {
        return this.$k.imagebase + this.url
      }
      return ''
    }
  },
  
  data () {
    return {
      showing: true
    }
  },
  mounted () {
    this.mountMedia()
  },
  methods: {
    mountMedia () {
      this.media = this.$refs.media
      this.media.addEventListener('canplay', this.checkPlay)
    },
    checkPlay () {
      this.media.removeEventListener('canplay', this.checkplay)
      this.$emit('load', { width: this.$el.offsetWidth, height: this.$el.offsetHeight })
      if(this.autoplay) {
        this.media.play()
      }
    }
  },
  beforeDestroy () {
    if(this.media){
      this.media.pause() // there is no stop
      this.media.removeEventListener('canplay', this.checkplay)

    }
  },
  watch: {
    url () {
      this.showing = false
      this.$nextTick(() => {
        // have to clear the old one out of html or it just won't end
        this.showing = true
        this.$nextTick(() => {
          this.mountMedia()
        })
      })
      
    }
  }
}
</script>

<style>
.zoomed-video{
  max-height:80vh;
  max-width:100%;
  display:block;
  box-sizing: border-box;
}

.inpage .zoomed-video{
  max-height: none;
}
</style>